import * as React from "react";
import { match, Redirect } from "react-router-dom";
import { dashboardRoute, organisationDashboardRoute } from "../index";

type MatchProps = {
  organisationID?: string;
};

type Props = {
  match: match<MatchProps>;
};

const Organisation = function (props: Props) {
  const { organisationID } = props.match.params;

  if (organisationID == null) {
    return <Redirect to={dashboardRoute()} />;
  }

  return <Redirect to={organisationDashboardRoute(organisationID)} />;
};

export default Organisation;
